import classNames from 'classnames';
import { forwardRef } from 'react';
const layoutItemVerticalScrollCss = "lipp8rl";
const layoutItemHorizontalScrollCss = "l1dw327c";
const layoutItemGrowCss = "lva5wbg";
const layoutItemNoShrinkCss = "l1ihlko6";
const layoutItemRelativeCss = "lbymxc";
const layoutItemPadding0Css = "lr5e9s8";
const layoutItemPadding4Css = "l14n3v7u";
const layoutItemPadding8Css = "lcjkol9";
const layoutItemPadding12Css = "l1itfqn0";
const layoutItemPadding16Css = "l1veylbl";
const layoutItemPadding20Css = "l1ro1oqb";
const layoutItemPadding24Css = "lph2jvf";
const layoutItemPadding32Css = "lqcqx22";
const layoutItemPadding48Css = "l1sxvpho";
const layoutItemPaddingY0Css = "l1g77oe3";
const layoutItemPaddingY4Css = "l21tuwd";
const layoutItemPaddingY8Css = "lihdi5x";
const layoutItemPaddingY12Css = "l1a6vcuc";
const layoutItemPaddingY16Css = "lnwvif6";
const layoutItemPaddingY20Css = "llzb60k";
const layoutItemPaddingY24Css = "l77fdwy";
const layoutItemPaddingY32Css = "l6lylri";
const layoutItemPaddingY48Css = "l1hxpnmf";
const layoutItemPaddingX0Css = "lm2a18y";
const layoutItemPaddingX4Css = "l10uhut4";
const layoutItemPaddingX8Css = "lb73ye5";
const layoutItemPaddingX12Css = "l1gaxilv";
const layoutItemPaddingX16Css = "lsr7vgd";
const layoutItemPaddingX20Css = "lzuvsae";
const layoutItemPaddingX24Css = "la160ez";
const layoutItemPaddingX32Css = "l1qwl7pg";
const layoutItemPaddingX48Css = "lv18401";
const layoutItemPaddingTop0Css = "l19po7y1";
const layoutItemPaddingTop4Css = "l1rcrciz";
const layoutItemPaddingTop8Css = "l1pspo1k";
const layoutItemPaddingTop12Css = "l3k0j1v";
const layoutItemPaddingTop16Css = "l1v59ofa";
const layoutItemPaddingTop20Css = "lqsm4hz";
const layoutItemPaddingTop24Css = "l4k9ma1";
const layoutItemPaddingTop32Css = "lzc4gzp";
const layoutItemPaddingTop48Css = "lwceobx";
const layoutItemPaddingBottom0Css = "l1859ikk";
const layoutItemPaddingBottom4Css = "lc46fd9";
const layoutItemPaddingBottom8Css = "lvcgzle";
const layoutItemPaddingBottom12Css = "l138xgnh";
const layoutItemPaddingBottom16Css = "l188if0u";
const layoutItemPaddingBottom20Css = "l17h6t26";
const layoutItemPaddingBottom24Css = "l1bvp0ci";
const layoutItemPaddingBottom32Css = "l9ob6r9";
const layoutItemPaddingBottom48Css = "ln5alm1";
const layoutItemPaddingLeft0Css = "lf0p647";
const layoutItemPaddingLeft4Css = "l1v0i9x0";
const layoutItemPaddingLeft8Css = "l1gyytas";
const layoutItemPaddingLeft12Css = "l1ojsw1o";
const layoutItemPaddingLeft16Css = "l1g551fw";
const layoutItemPaddingLeft20Css = "lj9ffey";
const layoutItemPaddingLeft24Css = "l1t7mrxl";
const layoutItemPaddingLeft32Css = "ljw2d4i";
const layoutItemPaddingLeft48Css = "l7igqvn";
const layoutItemPaddingRight0Css = "l13m56nn";
const layoutItemPaddingRight4Css = "lv9t681";
const layoutItemPaddingRight8Css = "lgdra07";
const layoutItemPaddingRight12Css = "lhjpcu9";
const layoutItemPaddingRight16Css = "l91mxpt";
const layoutItemPaddingRight20Css = "l14eg8xr";
const layoutItemPaddingRight24Css = "l1icgj56";
const layoutItemPaddingRight32Css = "l19upi57";
const layoutItemPaddingRight48Css = "lfqjtea";
const layoutItemCss = "l1ctcng5";
export const LayoutItem = forwardRef((props, ref) => {
  const {
    verticalScroll,
    horizontalScroll,
    grow,
    noShrink,
    relative,
    padding,
    paddingY,
    paddingX,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(layoutItemCss, {
    [layoutItemVerticalScrollCss]: verticalScroll,
    [layoutItemHorizontalScrollCss]: horizontalScroll,
    [layoutItemGrowCss]: grow,
    [layoutItemNoShrinkCss]: noShrink,
    [layoutItemRelativeCss]: relative,
    [layoutItemPadding0Css]: padding?.toString() === '0',
    [layoutItemPadding4Css]: padding?.toString() === '4',
    [layoutItemPadding8Css]: padding?.toString() === '8',
    [layoutItemPadding12Css]: padding?.toString() === '12',
    [layoutItemPadding16Css]: padding?.toString() === '16',
    [layoutItemPadding20Css]: padding?.toString() === '20',
    [layoutItemPadding24Css]: padding?.toString() === '24',
    [layoutItemPadding32Css]: padding?.toString() === '32',
    [layoutItemPadding48Css]: padding?.toString() === '48',
    [layoutItemPaddingY0Css]: paddingY?.toString() === '0',
    [layoutItemPaddingY4Css]: paddingY?.toString() === '4',
    [layoutItemPaddingY8Css]: paddingY?.toString() === '8',
    [layoutItemPaddingY12Css]: paddingY?.toString() === '12',
    [layoutItemPaddingY16Css]: paddingY?.toString() === '16',
    [layoutItemPaddingY20Css]: paddingY?.toString() === '20',
    [layoutItemPaddingY24Css]: paddingY?.toString() === '24',
    [layoutItemPaddingY32Css]: paddingY?.toString() === '32',
    [layoutItemPaddingY48Css]: paddingY?.toString() === '48',
    [layoutItemPaddingX0Css]: paddingX?.toString() === '0',
    [layoutItemPaddingX4Css]: paddingX?.toString() === '4',
    [layoutItemPaddingX8Css]: paddingX?.toString() === '8',
    [layoutItemPaddingX12Css]: paddingX?.toString() === '12',
    [layoutItemPaddingX16Css]: paddingX?.toString() === '16',
    [layoutItemPaddingX20Css]: paddingX?.toString() === '20',
    [layoutItemPaddingX24Css]: paddingX?.toString() === '24',
    [layoutItemPaddingX32Css]: paddingX?.toString() === '32',
    [layoutItemPaddingX48Css]: paddingX?.toString() === '48',
    [layoutItemPaddingTop0Css]: paddingTop?.toString() === '0',
    [layoutItemPaddingTop4Css]: paddingTop?.toString() === '4',
    [layoutItemPaddingTop8Css]: paddingTop?.toString() === '8',
    [layoutItemPaddingTop12Css]: paddingTop?.toString() === '12',
    [layoutItemPaddingTop16Css]: paddingTop?.toString() === '16',
    [layoutItemPaddingTop20Css]: paddingTop?.toString() === '20',
    [layoutItemPaddingTop24Css]: paddingTop?.toString() === '24',
    [layoutItemPaddingTop32Css]: paddingTop?.toString() === '32',
    [layoutItemPaddingTop48Css]: paddingTop?.toString() === '48',
    [layoutItemPaddingBottom0Css]: paddingBottom?.toString() === '0',
    [layoutItemPaddingBottom4Css]: paddingBottom?.toString() === '4',
    [layoutItemPaddingBottom8Css]: paddingBottom?.toString() === '8',
    [layoutItemPaddingBottom12Css]: paddingBottom?.toString() === '12',
    [layoutItemPaddingBottom16Css]: paddingBottom?.toString() === '16',
    [layoutItemPaddingBottom20Css]: paddingBottom?.toString() === '20',
    [layoutItemPaddingBottom24Css]: paddingBottom?.toString() === '24',
    [layoutItemPaddingBottom32Css]: paddingBottom?.toString() === '32',
    [layoutItemPaddingBottom48Css]: paddingBottom?.toString() === '48',
    [layoutItemPaddingLeft0Css]: paddingLeft?.toString() === '0',
    [layoutItemPaddingLeft4Css]: paddingLeft?.toString() === '4',
    [layoutItemPaddingLeft8Css]: paddingLeft?.toString() === '8',
    [layoutItemPaddingLeft12Css]: paddingLeft?.toString() === '12',
    [layoutItemPaddingLeft16Css]: paddingLeft?.toString() === '16',
    [layoutItemPaddingLeft20Css]: paddingLeft?.toString() === '20',
    [layoutItemPaddingLeft24Css]: paddingLeft?.toString() === '24',
    [layoutItemPaddingLeft32Css]: paddingLeft?.toString() === '32',
    [layoutItemPaddingLeft48Css]: paddingLeft?.toString() === '48',
    [layoutItemPaddingRight0Css]: paddingRight?.toString() === '0',
    [layoutItemPaddingRight4Css]: paddingRight?.toString() === '4',
    [layoutItemPaddingRight8Css]: paddingRight?.toString() === '8',
    [layoutItemPaddingRight12Css]: paddingRight?.toString() === '12',
    [layoutItemPaddingRight16Css]: paddingRight?.toString() === '16',
    [layoutItemPaddingRight20Css]: paddingRight?.toString() === '20',
    [layoutItemPaddingRight24Css]: paddingRight?.toString() === '24',
    [layoutItemPaddingRight32Css]: paddingRight?.toString() === '32',
    [layoutItemPaddingRight48Css]: paddingRight?.toString() === '48'
  }, props.className)} />;
});
const layoutWrapCss = "lrvg1qx";
const layoutDirectionRowCss = "lufclpt";
const layoutDirectionReverseRowCss = "lvek39x";
const layoutDirectionColumnCss = "lbkagq3";
const layoutDirectionReverseColumnCss = "lzdv61j";
const layoutJustifySpaceBetweenCss = "l11beha0";
const layoutJustifyCenterCss = "ldznvxt";
const layoutJustifyStartCss = "l1dmoa26";
const layoutAlignBaselineCss = "l14frebk";
const layoutAlignCenterCss = "laxip4b";
const layoutAlignStretchCss = "l152ulqp";
const layoutAlignStartCss = "l1kxnx7a";
const layoutGap0Css = "l13ecjyf";
const layoutGap4Css = "lw1jth5";
const layoutGap8Css = "l171iglm";
const layoutGap12Css = "lh9morr";
const layoutGap16Css = "l14pifjo";
const layoutGap20Css = "l19shgtv";
const layoutGap24Css = "liobfas";
const layoutGap32Css = "l1mq3u4f";
const layoutGap48Css = "l4qp579";
const layoutGapY0Css = "lry4ryh";
const layoutGapY4Css = "l1i7t2cq";
const layoutGapY8Css = "lp36zq2";
const layoutGapY12Css = "l18770of";
const layoutGapY16Css = "l1kxmzb0";
const layoutGapY20Css = "l7ilqwa";
const layoutGapY24Css = "l10z6cfb";
const layoutGapY32Css = "l1e1xjdp";
const layoutGapY48Css = "l1wsome2";
const layoutGapX0Css = "lvtlqdg";
const layoutGapX4Css = "l13xi14q";
const layoutGapX8Css = "l1wsppkg";
const layoutGapX12Css = "l1hv2ub9";
const layoutGapX16Css = "lvh2nh5";
const layoutGapX20Css = "la1o0ca";
const layoutGapX24Css = "l1qfn14h";
const layoutGapX32Css = "l1xb15sk";
const layoutGapX48Css = "lu3g58c";
const layoutCss = "l11fifyj";
export const Layout = forwardRef((props, ref) => {
  const {
    wrap,
    direction,
    justify,
    align,
    gap,
    gapY,
    gapX,
    ...restProps
  } = props;
  return <LayoutItem ref={ref} {...restProps} className={classNames(layoutCss, {
    [layoutWrapCss]: wrap,
    [layoutDirectionRowCss]: direction?.toString() === 'row',
    [layoutDirectionReverseRowCss]: direction?.toString() === 'row-reverse',
    [layoutDirectionColumnCss]: direction?.toString() === 'column',
    [layoutDirectionReverseColumnCss]: direction?.toString() === 'column-reverse',
    [layoutJustifySpaceBetweenCss]: justify?.toString() === 'space-between',
    [layoutJustifyCenterCss]: justify?.toString() === 'center',
    [layoutJustifyStartCss]: justify?.toString() === 'start',
    [layoutAlignBaselineCss]: align?.toString() === 'baseline',
    [layoutAlignCenterCss]: align?.toString() === 'center',
    [layoutAlignStretchCss]: align?.toString() === 'stretch',
    [layoutAlignStartCss]: align?.toString() === 'start',
    [layoutGap0Css]: gap?.toString() === '0',
    [layoutGap4Css]: gap?.toString() === '4',
    [layoutGap8Css]: gap?.toString() === '8',
    [layoutGap12Css]: gap?.toString() === '12',
    [layoutGap16Css]: gap?.toString() === '16',
    [layoutGap20Css]: gap?.toString() === '20',
    [layoutGap24Css]: gap?.toString() === '24',
    [layoutGap32Css]: gap?.toString() === '32',
    [layoutGap48Css]: gap?.toString() === '48',
    [layoutGapY0Css]: gapY?.toString() === '0',
    [layoutGapY4Css]: gapY?.toString() === '4',
    [layoutGapY8Css]: gapY?.toString() === '8',
    [layoutGapY12Css]: gapY?.toString() === '12',
    [layoutGapY16Css]: gapY?.toString() === '16',
    [layoutGapY20Css]: gapY?.toString() === '20',
    [layoutGapY24Css]: gapY?.toString() === '24',
    [layoutGapY32Css]: gapY?.toString() === '32',
    [layoutGapY48Css]: gapY?.toString() === '48',
    [layoutGapX0Css]: gapX?.toString() === '0',
    [layoutGapX4Css]: gapX?.toString() === '4',
    [layoutGapX8Css]: gapX?.toString() === '8',
    [layoutGapX12Css]: gapX?.toString() === '12',
    [layoutGapX16Css]: gapX?.toString() === '16',
    [layoutGapX20Css]: gapX?.toString() === '20',
    [layoutGapX24Css]: gapX?.toString() === '24',
    [layoutGapX32Css]: gapX?.toString() === '32',
    [layoutGapX48Css]: gapX?.toString() === '48'
  }, props.className)} />;
});

require("./layout.wyw-in-js.css!=!../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./layout.js");